import { render, staticRenderFns } from "./pagination.vue?vue&type=template&id=e57d9e78&scoped=true&lang=pug"
import script from "./pagination.vue?vue&type=script&lang=ts"
export * from "./pagination.vue?vue&type=script&lang=ts"
import style0 from "./pagination.vue?vue&type=style&index=0&id=e57d9e78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e57d9e78",
  null
  
)

export default component.exports